import {
  DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_BEGIN,
  DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SUCCESS,
  DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_FAILURE,
  DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';

export function updateMySqlExternalDb(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_BEGIN,
    });
    const {
      projectId,
      version,
      externalDatabaseId,
      fields,
      tableIndex,
      collectionTitle,
      selectedPrimaryKey,
      isExistingCollection,
      mappedCollectionId,
      mappedCollectionName,
      mappedCollectionFields,
    } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/mysql/externalDb/${externalDatabaseId}`,
        {
          fields,
          tableIndex: tableIndex,
          collectionTitle,
          selectedPrimaryKey,
          isExistingCollection,
          mappedCollectionId,
          mappedCollectionName,
          mappedCollectionFields,
        },
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateMySqlExternalDbError() {
  return {
    type: DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updateMySqlExternalDbPending: true,
        updateMySqlExternalDbError: null,
      };

    case DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SUCCESS:
      // The request is success
      return {
        ...state,
        updateMySqlExternalDbPending: false,
        updateMySqlExternalDbError: null,
      };

    case DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_FAILURE:
      // The request is failed
      return {
        ...state,
        updateMySqlExternalDbPending: false,
        updateMySqlExternalDbError: action.data.error,
      };

    case DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updateMySqlExternalDbError: null,
      };

    default:
      return state;
  }
}
